import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/ux-fabric"

export const Wrapper = styled("div")`
    position: absolute;
    height: 2.75rem;
    font-size: 0.9375rem;
`

export const ButtonContainer = styled("div", {
    shouldForwardProp: prop => prop !== "applyMarginCompensation",
})<{applyMarginCompensation?: boolean}>`
    display: flex;
    align-items: center;
    width: 2.75rem;
    height: 2.75rem;
    @media (min-width: ${breakpoints.values.md}px) {
        ${({applyMarginCompensation}) => (applyMarginCompensation ? "margin-left: 0.5rem;" : "")}
    }
`
